
import { TemplateSet } from '@/types/bannerTemplate';

// Mock data for templates - in a real app this would come from an API
export const TEMPLATE_SETS: TemplateSet[] = [
  {
    id: 'template-set-1',
    name: 'Summer Sale Collection',
    description: 'Bright and vibrant templates for summer promotions',
    thumbnailUrl: 'https://picsum.photos/300/250?random=summer',
    createdAt: new Date(),
    category: 'Seasonal',
    tags: ['summer', 'sale', 'promotion'],
    templates: [
      {
        id: 'template-1',
        name: 'Summer Beach',
        description: 'Beach-themed summer sale template',
        thumbnailUrl: 'https://picsum.photos/300/250?random=beach',
        createdAt: new Date(),
        category: 'Seasonal',
        tags: ['summer', 'beach'],
        formats: [
          {
            size: 'medium_rectangle',
            imageUrl: 'https://picsum.photos/300/250?random=beach-med',
            isAnimated: false,
            originalFormat: 'jpg'
          },
          {
            size: 'leaderboard',
            imageUrl: 'https://picsum.photos/728/90?random=beach-lead',
            isAnimated: false,
            originalFormat: 'jpg'
          }
        ]
      },
      {
        id: 'template-2',
        name: 'Summer Fruits',
        description: 'Fruit-themed summer promotion',
        thumbnailUrl: 'https://picsum.photos/300/250?random=fruits',
        createdAt: new Date(),
        category: 'Seasonal',
        tags: ['summer', 'fruits'],
        formats: [
          {
            size: 'medium_rectangle',
            imageUrl: 'https://picsum.photos/300/250?random=fruits-med',
            isAnimated: true,
            originalFormat: 'gif'
          },
          {
            size: 'leaderboard',
            imageUrl: 'https://picsum.photos/728/90?random=fruits-lead',
            isAnimated: true,
            originalFormat: 'gif'
          }
        ]
      }
    ]
  },
  {
    id: 'template-set-2',
    name: 'Corporate Collection',
    description: 'Professional templates for business marketing',
    thumbnailUrl: 'https://picsum.photos/300/250?random=corporate',
    createdAt: new Date(),
    category: 'Business',
    tags: ['corporate', 'professional', 'business'],
    templates: [
      {
        id: 'template-3',
        name: 'Blue Corporate',
        description: 'Professional blue-themed template',
        thumbnailUrl: 'https://picsum.photos/300/250?random=corp-blue',
        createdAt: new Date(),
        category: 'Business',
        tags: ['corporate', 'blue'],
        formats: [
          {
            size: 'medium_rectangle',
            imageUrl: 'https://picsum.photos/300/250?random=corp-blue-med',
            isAnimated: false,
            originalFormat: 'png'
          },
          {
            size: 'leaderboard',
            imageUrl: 'https://picsum.photos/728/90?random=corp-blue-lead',
            isAnimated: false,
            originalFormat: 'png'
          }
        ]
      }
    ]
  }
];
